import type { JSX } from 'react'
import MfaSection from '../../components/agent/MfaSection.js'
import { useAuthStore } from '../../store/authStore.js'
import { ShieldCheck } from 'lucide-react'

export default function AdminMfaPage(): JSX.Element {
  const isSuperAdmin = useAuthStore((s) => s.user?.isSuperAdmin ?? false)
  const roles = useAuthStore((s) => s.user?.roles ?? [])
  const isPlatformAdmin = roles.some((r) => r === 'PLATFORM_ADMIN' || r === 'PLATFORM_SUPER_ADMIN')
  const mode = isSuperAdmin || isPlatformAdmin ? 'platform' : 'tenant'

  return (
    <div className="p-6">
      <div className="mx-auto max-w-3xl space-y-6">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-[#3366FF]">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Multi-Factor Authentication (MFA)</h1>
            <p className="text-xs text-gray-500">
              Manage your two-factor authentication credentials, authenticator application keys, and backup recovery codes.
            </p>
          </div>
        </div>

        <MfaSection mode={mode} />
      </div>
    </div>
  )
}
